/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
author: LowlyPoly (https://sketchfab.com/lowlypoly)
license: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
source: https://sketchfab.com/3d-models/stylized-crystal-0a0c75dab0844e7fa5b299d4af858bec
title: Stylized Crystal
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei/useGLTF'
import { useFrame } from 'react-three-fiber'

export default function Crystal(props) {
  const group = useRef()
  const { nodes, materials } = useGLTF('assets/crystal/scene.gltf')
  useFrame(()=>{
    if(group?.current){
      window.audioAnalyzerData.analyzer.getByteFrequencyData(window.audioAnalyzerData.dataArray);
      group.current.scale.x = window.audioAnalyzerData.dataArray[256]/128.0;
      group.current.scale.y = window.audioAnalyzerData.dataArray[128]/128.0;
      group.current.scale.z = window.audioAnalyzerData.dataArray[128]/128.0;
    }
  });
  return (
    <group ref={group} {...props} dispose={null}>
      <group rotation={[-Math.PI / 2, 0, 0]} >
        <group rotation={[Math.PI / 2, 0, 0]} scale={[0.5,0.5,0.5]}>
          <group position={[0, 0, 0]} scale={[16.99, 16.99, 16.99]}>
            <mesh material={materials.crystal_17_2} geometry={nodes.crystal17_2_crystal_17_2_0.geometry} />
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('assets/crystal/scene.gltf')
